import { render, staticRenderFns } from "./matchOutPopup.vue?vue&type=template&id=a9a54430&scoped=true&"
import script from "./matchOutPopup.vue?vue&type=script&lang=js&"
export * from "./matchOutPopup.vue?vue&type=script&lang=js&"
import style0 from "./matchOutPopup.vue?vue&type=style&index=0&id=a9a54430&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9a54430",
  null
  
)

export default component.exports